import {atom} from 'jotai';
import type {AnalyticsChannelFilter} from '@lib/atoms';
import type {AnalyticsSectionFilter} from './types';

/** Выбранный филиал привязан к Workspace, чтобы не переносить SID между клиентами. */
export const dashboardBranchAtom = atom<{
  workspaceSid: string | null;
  value: string;
}>({workspaceSid: null, value: 'all'});

/**
 * Таб «Аналитики за период» → срез запроса dashboard/rating: звонки —
 * `communicationKind: 'call'`, очные/онлайн — раздел встреч + `meetingChannel`;
 * «Все коммуникации» — без среза.
 */
export const analyticsSectionFilter = (
  channel: AnalyticsChannelFilter,
): AnalyticsSectionFilter =>
  channel === 'all'
    ? {}
    : channel === 'phone'
      ? {communicationKind: 'call'}
      : {communicationKind: 'meeting', meetingChannel: channel};
